import { ResponsiveMode } from '../../utilities/decorators/withResponsiveMode';
export { SelectableOptionMenuItemType as DropdownMenuItemType } from '../../utilities/selectableOption/SelectableOption.types';
export { ResponsiveMode }; // Exported because the type is an optional prop and not exported otherwise.
//# sourceMappingURL=Dropdown.types.js.map


//////////////////
// WEBPACK FOOTER
// /home/travis/build/proofdict/proofdict/node_modules/office-ui-fabric-react/lib/components/Dropdown/Dropdown.types.js
// module id = 157
// module chunks = 0